import i18n from "../../i18n/i18n";
const store = {
  namespaced: true,
  state: {
    taxIncludeList: [
      {
        label: i18n.t("base.yes"),
        value: "1"
      },
      {
        label: i18n.t("base.no"),
        value: "0"
      }
    ]
  },
  getters: {},
  mutations: {},
  actions: {
    async queryTransferWarehouseList({ rootState }, params = {}) {
      const data = await rootState.http("/transferWarehouse/page", params);
      return data;
    },
    async createTransferWarehouse({ rootState }, params = {}) {
      const data = await rootState.http("/transferWarehouse/create", params);
      return data;
    },
    async updateTransferWarehouse({ rootState }, params = {}) {
      const data = await rootState.http("/transferWarehouse/update", params);
      return data;
    },
    async comfirmTransferWarehouse({ rootState }, params = {}) {
      const data = await rootState.http("/transferWarehouse/confirm", params);
      return data;
    },
    async queryTransferWarehouseDetail({ rootState }, params = {}) {
      const data = await rootState.http("/transferWarehouse/detail", params);
      return data;
    },
    async cancelTransferWarehouse({ rootState }, params = {}) {
      const data = await rootState.http("/transferWarehouse/cancel", params);
      return data;
    },
    //op接口
    async opQueryStoreMode({ rootState }, params = {}) {
      const data = await rootState.http("/getStoreOrderMode", params);
      return data;
    }
  }
};

export default store;
